<template>
  <jd-dialog
    title="历史记录"
    :visible.sync="isShowHistory"
    width="40%"
    @close="closeDialog"
    :isShowSure="false"
  >
    <div>
      <jd-table
        :tableData="tableData"
        :tableInfo="tableInfo"
        :loading="loading"
        :pageInfo="{
          pageNum: pageInfo.current,
          pageSize: pageInfo.size,
          total: total,
        }"
        @handlePage="handlePageChange"
      >
        <template #operationSlot="{ row, rowIndex }">
          <jd-button type="blueText" @click="handleUse(row)">使用</jd-button>
          <jd-button type="blueText" @click="handleExport(row)">导出</jd-button>
        </template>
      </jd-table>
    </div>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    >
    </generate>
  </jd-dialog>
</template>
<script>
import generate from "@/components/generate_report.vue";
import {
  getXhsAIGeneratedList,
  aiGenerateDetailExport
} from "@/api/jhk/paradiseAndTaskCommonController";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    generate,
  },
  data() {
    return {
      exportRemark: "",
      control: false,
      loading: false,
      isShowHistory: false,
      tableData: [],
      tableInfo: [
        {
          prop: "generatedTime",
          label: "生成时间",
        },
        {
          prop: "keyWord",
          label: "内容关键词",
        },
        {
          prop: "contextMaxWord",
          label: "内容文案字数上限",
        },
        {
          prop: "generatedCount",
          label: "生成数量",
        },
        {
          prop: "operation",
          label: "操作",
          slot: "operationSlot",
        },
      ],
      pageInfo: {
        size: 10,
        current: 1,
      },
      total: 0,
      aiSkinAnalyseDetailId: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.isShowHistory = this.isShow;
    this.getList();
  },
  methods: {
    handlePageChange({ pageNum, pageSize }) {
      this.pageInfo.size = pageSize;
      this.pageInfo.current = pageNum;
      this.getList();
    },
    async getphone(val) {
      this.exportRemark = val;
      // 调接口
      try {
        const res = await aiGenerateDetailExport({
          recordId: this.aiSkinAnalyseDetailId,
          exportRemark: this.exportRemark,
        });
        if (res.code === 1) {
          this.$message({
            message: "导出成功",
            type: "success",
          });
        }
      } catch (error) {
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },
    closeDialog() {
      this.$emit("update:isShow", false);
    },
    handleUse(row) {
      this.closeDialog();
      this.$emit("use", row);
    },
    handleExport(row) {
      this.aiSkinAnalyseDetailId = row.id;
      this.control = true;
      this.exportRemark = "";
    },
    getList() {
      this.loading = true;
      getXhsAIGeneratedList({
        generatedType: 1,
        ...this.pageInfo,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handlePageChange({ pageNum, pageSize }) {
      this.pageInfo.current = pageNum;
      this.pageInfo.size = pageSize;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped></style>
